// hooks/useProductSearch.ts
import { useState } from 'react';
import { Product } from '../interface/interface';

const MAX_SUGGESTIONS = 20;

export function useProductSearch(
  products: Product[],
  onSearch: (term: string) => void,
) {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState<Product[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleChange = (text: string) => {
    setValue(text);

    if (!text.trim()) {
      setSuggestions([]);
      setShowDropdown(false);
      onSearch('');
      return;
    }

    const query = text.toLowerCase();

    const matches = products
      .filter(
        (p) =>
          p.product_brand?.toLowerCase().includes(query) ||
          p.name?.toLowerCase().includes(query) ||
          p.productCondition?.some((c) =>
            c.condition?.toLowerCase().includes(query),
          ),
      )
      .slice(0, MAX_SUGGESTIONS);

    setSuggestions(matches);
    setShowDropdown(matches.length > 0);
    onSearch(text.trim());
  };

  return {
    value,
    setValue,
    suggestions,
    showDropdown,
    setShowDropdown,
    handleChange,
  };
}
